/**
 * This component is a collection of Base Components
 * and provides simple components such as pure texts
 * and feed items.
 *
 * @summary A collection of base components
 * @author MonkeyFigaro <monkeychen@sohu-inc.com>
 *
 * Created at     : 2019-03-15 14:53:46
 * Last modified  : 2019-07-22 16:07:21
 */
export { TextFeedItem } from './TextFeedItem';
export { ImageFeedItem } from './ImageFeedItem';
export { FocusImage } from './FocusImage';
export { FocusImageLoading } from './FocusImage.loading';
export { TextCompLoading } from './TextFeedItem.loading';
export { TitleLoading } from './Title.loading';
export { ItemImageLoading } from './ImageFeedItem.loading';
export { GroupContainer } from './GroupContainer';
export { LinkWrapper } from './LinkWrapper';



// WEBPACK FOOTER //
// ./src/components/BaseComp/index.ts